// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"ec18197c","200":"e9e483ce","402":"4da4dcc1","424":"4e0cf72c","535":"f726c7c1","756":"c7059cdb"}[chunkId] + ".chunk.js";
};